// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
   //baseUrl: 'http://127.0.0.1:8000/api/v1',//api.dev.slik.mt
   //baseUrl: 'http://api-dckrtd01-lwe.eprmalta.local/api/v1',//api.dev.slik.mt
    baseUrl: 'https://rtd-public.gov.mt/api/v1',//api.dev.slik.mt
  per_page : 25,
  mapUrl:"https://maps.google.com/maps/api/js?key=",
  ws_url: "",
  dummy_data:[ ]
};